import Vue from 'vue'
import { $, $$, BREAKPOINTS } from '../_utils'
import EventBus from '../_event-bus'

Vue.component('vue-date-picker', {
  template: '#vue-date-picker-template',
  props: ['selected', 'isYearBlocked', 'name'],
  data() {
    return {
      layout: '',
      daysNumbers: this.generateDaysNubers(),
      years: this.generateYearsArray(),
      months: [
        { value: '00', label: 'miesiąc' },
        { value: '01', label: 'Styczeń' },
        { value: '02', label: 'Luty' },
        { value: '03', label: 'Marzec' },
        { value: '04', label: 'Kwiecień' },
        { value: '05', label: 'Maj' },
        { value: '06', label: 'Czerwiec' },
        { value: '07', label: 'Lipiec' },
        { value: '08', label: 'Sierpień' },
        { value: '09', label: 'Wrzesień' },
        { value: '10', label: 'Październik' },
        { value: '11', label: 'Listopad' },
        { value: '12', label: 'Grudzień' },
      ],
      activeDate: this.setInitialActiveDate(),
      pickedDay: '',
      pickedMonth: '',
      pickedYear: '',
      wrapperName: '',
    }
  },
  methods: {
    // SET EVENTS LISTENERS

    addSendFormEventListener() {
      EventBus.$on('submit-form', this.handleSubmit)
    },
    addChoicesListener() {
      EventBus.$on('date-selected', this.handleSelect)
    },

    // GENERATE CHOICES ARRAYS

    generateDaysNubers() {
      const daysNumbers = []
      for (let i = 1; i <= 31; i++) {
        daysNumbers.push({ value: i < 10 ? `0${i}` : `${i}`, label: i < 10 ? `0${i}` : `${i}` })
      }
      daysNumbers.unshift({ value: 'dzień', label: 'dzień' })
      return daysNumbers
    },
    generateYearsArray() {
      const date = new Date()
      const yearsArray = []
      if (!this.$props.isYearBlocked) {
        for (let i = 0; i <= 100; i++) {
          yearsArray.push({ value: date.getFullYear() - i, label: date.getFullYear() - i })
        }
        yearsArray.unshift({ value: 'rok', name: 'rok' })
      } else {
        yearsArray.push({ value: date.getFullYear(), label: date.getFullYear() })
      }
      return yearsArray
    },
    setDisabledYearField() {
      if (this.$props.isYearBlocked) {
        const yearsSelect = $('.date-picker__item--years .choices__inner', this.$refs.parent)
        $('.date-picker__item--years', this.$refs.parent).style.pointerEvents = 'none'
        $('.date-picker__item--years .choices__inner', this.$refs.parent).style.backgroundColor =
          '#f9fbff'
        yearsSelect.style.color = '#d8dbe2'
        $(
          '.date-picker__item--years .choices[data-type*=select-one',
          this.$refs.parent
        ).classList.add('pick-disabled')
      }
    },

    // EMIT EVENTS

    emitDatePickerUpdate() {
      EventBus.$emit('date-picker-data-updated', {
        activeDate: this.activeDate,
        name: this.$props.name,
      })
    },

    // HANDLE EVENTS

    handleSelect(data) {
      if (this.$props.name !== data.name) return
      switch (data.type) {
        case 'day':
          this.pickedDay = data.choice
          break
        case 'month':
          this.pickedMonth = data.choice
          break
        case 'year':
          this.pickedYear = data.choice
          break
        default:
          return
      }
      this.setActiveDate()
      this.setActiveItems()
      this.emitDatePickerUpdate()
    },

    // SET VALUES

    setActiveItems() {
      // get day, month and year from activeDate

      const [year, month, day] = this.activeDate.split('-')

      // set picked day, month and year

      this.setPickedItems(day, month, year)

      // set selected day, month and year

      this.daysNumbers.forEach(item => {
        if (item.value == this.pickedDay) {
          item.selected = true
        }
      })

      this.months.forEach(item => {
        if (item.value === this.pickedMonth) item.selected = true
      })

      this.years.forEach(item => {
        if (item.value === parseInt(this.pickedYear)) item.selected = true
      })
    },
    setInitialActiveDate() {
      if (this.$props.isYearBlocked) {
        return (this.activeDate = this.$props.selected
          ? this.$props.selected
          : `${new Date().getFullYear()}-miesiąc-dzień`)
      } else
        return (this.activeDate = this.$props.selected ? this.$props.selected : `rok-miesiąc-dzień`)
    },
    setActiveDate() {
      this.activeDate = `${this.pickedYear}-${this.pickedMonth}-${this.pickedDay}`
      if (this.$props.isYearBlocked)
        this.activeDate = `${new Date().getFullYear()}-${this.pickedMonth}-${this.pickedDay}`
    },

    // SET SELECTED CHOICES

    setPickedItems(day, month, year) {
      if (day) this.pickedDay = day
      if (month) this.pickedMonth = month
      if (year) this.pickedYear = year
    },
  },
  created() {
    this.addChoicesListener()
    this.setActiveItems()
    this.name = this.$props.name
  },
  mounted() {
    this.setDisabledYearField()
  },
})

const datePickers = $$('#vue-date-picker-wrapper')
window.addEventListener('DOMContentLoaded', () => {
  if (!datePickers) return
  datePickers.forEach(element => {
    new Vue({
      el: element,
    })
  })
})
